import { InjectionToken } from '@angular/core';

export interface BreadcrumbItem {
  label: string;
  url?: string;
  route?: string;
  icon?: string;
  children?: BreadcrumbItem[];
  [key: string]: any;
}

export interface BreadcrumbSyncService {
  getCurrent(): BreadcrumbItem[];
  update(items: BreadcrumbItem[]): void;
}

export const BREADCRUMB_SYNC_SERVICE = new InjectionToken<BreadcrumbSyncService>(
  'BREADCRUMB_SYNC_SERVICE',
);

export const CUSTOM_ICONS_TOKEN = new InjectionToken<string[]>('CUSTOM_ICONS_TOKEN');

export const DEFAULT_CUSTOM_ICONS = [
  'Folder',
  'House',
  'FileText',
  'Settings',
  'Users',
  'BarChart3',
  'LayoutDashboard',
  'Wallet',
  'Search',
  'ChevronRight',
  'ChevronLeft',
  'X',
  'Plus',
  'Trash2',
  'Save',
  'Home',
  'User',
  'CreditCard',
  'DollarSign',
  'Check',
  'AlertCircle',
  'CircleArrowLeft',
  'Tags',
  'Shield',
  'BetweenHorizontalEnd',
  'Building2',
  'ArchiveRestore',
  'File',
  'Cloud',
  'Activity',
  'Key',
  'Server',
  'FolderUp',
  'FolderLock',
  'FolderSync',
  'FolderKanban',
  'FolderGit2',
  'SearchCheck',
  'SquareKanban',
  'Users',
  'UserKey',
  'HardDrive',
  'FolderArchive',
  'House',
  'Folder',
  'FileSliders',
  'UserStar',
  'Gauge',
  'File',
  'Vault',
  'MessageSquareDot',
  'Boxes',
  'Receipt',
  'Landmark',
  'LibraryBig',
  'Pen',
  'Eye',
  'Layers',
  'Form',
];
